<template>
    <q-page class="">
        <p class="q-display-1">Linki</p>

        <p class="q-body-1">Dodaj poniżej odpowiedni plik CSV z definicjami linków, obiektów sportowych oraz placówek oferujących pomoc.</p>

        <p class="q-body-1" v-if="info">
            Dane aktualizowane byly ostatnio <strong>{{info.uploadTs.fromNow()}}</strong>.
            <a href="#" @click.prevent="removeAll">Usuń wszystko</a>
            | <a href="#" @click.prevent="publishAll">Opublikuj wszystko</a>
        </p>
        <p class="q-body-1" v-else>
            <strong>Żadne dane nie zostały jeszcze dodane</strong>.
        </p>

        <upload dispatch="uploadCsvFile" @uploaded="forceReload">

        </upload>

        <q-table
            title="Lista dodanych obiektów"
            :data="data"
            :rows-per-page-options="[20, 100, 0]"
            :pagination.sync="paginationControl"
            :columns="columns"
            row-key="contentId"
        >
            <q-td slot="body-cell-href" slot-scope="props" :props="props">
                <a
                    :href="props.row.href"
                    target="_blank">Link</a>
            </q-td>

            <q-td slot="body-cell-dataType" slot-scope="props" :props="props">
                <q-icon
                    v-if="props.row.dataType == 'links'"
                    name="accessibility"></q-icon>
                <q-icon
                    v-if="props.row.dataType == 'help_facility'"
                    name="local_hospital"></q-icon>
                <q-icon
                    v-if="props.row.dataType == 'sport'"
                    name="input"></q-icon>
            </q-td>
        </q-table>
    </q-page>
</template>

<script>
    import Upload from './Upload'
    import QTable from 'quasar-framework/src/components/table/QTable'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    export default {
        name: 'Activities',
        data () {
            return {
                columns: [
                    {
                        name: 'lp',
                        label: '#',
                        align: 'left',
                        field: 'lp',
                        sortable: true,
                        classes: '',
                        style: '',
                        sort: (a, b) => {
                            return parseInt(a, 10) - parseInt(b, 10)
                        }
                    },
                    {
                        name: 'dataType',
                        align: 'left',
                        field: 'dataType',
                        sortable: true,
                        classes: '',
                        style: '',
                    },
                    {
                        name: 'label',
                        label: 'Nazwa',
                        align: 'left',
                        field: 'label',
                        sortable: true,
                        classes: '',
                        style: ''
                    },
                    {
                        name: 'JST',
                        label: 'JST',
                        align: 'left',
                        field: 'JST',
                        sortable: true,
                        classes: '',
                        style: ''
                    },
                    {
                        name: 'addresses',
                        label: 'Adres',
                        align: 'left',
                        field: 'addresses',
                        sortable: true,
                        classes: '',
                        style: ''
                    },
                    {
                        name: 'county',
                        label: 'Powiat',
                        align: 'left',
                        field: 'county',
                        sortable: true,
                        classes: '',
                        style: ''
                    },
                    {
                        name: 'href',
                        label: 'Pozycja',
                        align: 'left',
                        sortable: true,
                        classes: '',
                        style: '',
                        field: 'href',
                    },
                    {
                        name: 'voivodeship',
                        label: 'Województwo',
                        align: 'left',
                        field: 'voivodeship',
                        sortable: true,
                        classes: '',
                        style: ''
                    },
                    {
                        name: 'zoneVariant',
                        label: 'Strefa',
                        align: 'left',
                        field: 'zoneVariant',
                        sortable: true,
                        classes: '',
                        style: ''
                    },
                    {
                        name: 'url',
                        label: 'URL',
                        align: 'left',
                        field: 'url',
                        sortable: true,
                        classes: '',
                        style: ''
                    },
                    {
                        name: 'category',
                        label: 'Kategoria',
                        align: 'left',
                        field: 'category',
                        sortable: true,
                        classes: '',
                        style: ''
                    },
                ],
                paginationControl: {
                    rowsPerPage: 20,
                        page: 1
                }
            }
        },
        components: {QIcon, QTable, Upload},
        mounted () {
            this.fetch()
        },
        methods: {
            fetch () {
                this.$store.dispatch('fetchCsvInfo')

                this.$store.dispatch('fetchAll', {
                    what: 'csv'
                })
            },
            async forceReload () {
                await this.$store.dispatch('fetchAll', {
                    what: 'csv',
                    force: true
                })

                // now publish all...

                this.data.reduce((prom, item) => {
                    return prom.then(() => {
                        if (! item.publicationInformation || item.publicationInformation.status !== 'Published') {
                            return this.$store.dispatch('publish', {
                                what: 'csv',
                                item: item,
                                notify: false
                            })
                        }

                        return Promise.resolve();
                    })
                }, Promise.resolve())

            },
            removeAll () {
                this.$q.dialog({
                    title: `Potwierdź usunięcie danych POI`,
                    message: `Czy na pewno usunąć wszystkie dane POI?`,
                    ok: 'Usuń',
                    cancel: 'Anuluj',
                    position: 'top',
                }).then(() => {
                    const result = this.data.reduce((prom, item) => {
                        return prom.then(() => {
                            if (item.publicationInformation && item.publicationInformation.status === 'Published') {
                                return this.$store.dispatch('unpublish', {
                                    what: 'csv',
                                    item: item,
                                    notify: false
                                })
                            }

                            return Promise.resolve();
                        })
                    }, Promise.resolve())

                    result.then(() => {
                        this.data.reduce((prom, item) => {
                            return prom.then(() => {
                                return this.$store.dispatch('remove', {
                                    what: 'csv',
                                    item: item,
                                    notify: false
                                })
                            })
                        }, Promise.resolve())
                    })
                }).catch(() => {

                })
            },
            publishAll () {
                this.data.reduce((prom, item) => {
                    return prom.then(() => {
                        return this.$store.dispatch('publish', {
                            what: 'csv',
                            item: item
                        })
                    })
                }, Promise.resolve())
            },
        },
        computed: {
            info () {
                return this.$store.state.csvInfo
            },

            data () {
                return (this.$store.getters.csv || []).map(entry => ({
                    ...entry,
                    href: `https://www.google.com/maps/search/?api=1&query=${entry.lat},${entry.lon}`
                }))
            },
        },
    }
</script>

<style scoped lang="scss">

</style>